import axios from 'axios';

const DemandService = {
  async createDemand({ formValues, loanId, invoiceIds }) {
    const values = {
      ...formValues,
      loan_id: loanId,
      invoice_id: invoiceIds,
    };

    const response = await axios.post('/demand', values);

    return response.data;
  },

  async getDemand(demandId) {
    const response = await axios.get(`/demand/${demandId}`);

    return response.data;
  },

  async updateDemand({ formValues, demandId }) {
    const response = await axios.put(`/demand/${demandId}`, formValues);

    return response.data;
  },

  async mailDemand({ demandId, deliveryId }) {
    const response = await axios.post(`/demand/${demandId}/mail`, {
      delivery_id: deliveryId,
    });

    return response.data;
  },

  async deleteDemand(demandId) {
    const response = await axios.delete(`/demand/${demandId}`);

    return response.data;
  },

  async accelerateDemand(demandId) {
    const response = await axios.post(`/demand/${demandId}/accelerate`);

    return response.data;
  },
};

export default DemandService;
